import { createContentPropTypes } from '../../helpers/content';

const content = {
	title: 'Authorise payment',
	batchTitle: 'Authorise',
	bacsTitle: 'Authorise',
	bacsPaymentDeadlineTitle: 'Bacs payment deadline',
	bacsAuthoriseMsg:
		'Please remember that Bacs payments must be authorised by 5.10pm to meet your planned submission and settlement dates.',
	chapsTitle: 'Authorise CHAPS Payment',
	chapsAuthoriseMsg:
		'Please remember that CHAPS payments must be authorised by 5pm to meet your planned submission and settlement dates.',
	iftAuthoriseMsg:
		'Please check the live exchange rate and review the payment details below before you authorise this payment.',
	refreshLiveRateMsg:
		'If you have to refresh the rate, please check the details again to make sure you’re happy before you authorise the payment.',
	iftNotFinalApprovalTitle:
		'Please review the payment details below before you provide authorisation (this payment will also need authorised by another user).',
	iftNotFinalApprovalMsg:
		'As the exchange rate isn’t booked until final authorisation, the highlighted amounts have been calculated using an indicative rate and are subject to change. The exact amounts will be clearly shown to the other user when it comes to providing final authorisation.',
	iftPreBookedRateTitle: 'Please review the payment details below before you provide authorisation.',
	iftPreBookedRateMsg:
		'We’ll have to manually review this payment as it was set up using a pre-booked exchange rate, which means the figures highlighted may be subject to change.',
	twoStepAuthoriseContent:
		'Once you’ve confirmed this payment, please log in to your mobile banking app to provide final authorisation.',
	back: 'Back',
	authoriseOnMobile: 'Confirm',
	twoStepAuthoriseInstruction:
		'Please review and confirm the payment details are correct before you complete the first stage of authorisation.',
	status: 'Status',
	authorisationRequired: 'Authorisation Required',
	mobileBankingApp: 'Using our mobile banking app',
	twoStepReviewDetails:
		'Please review the details below, then log in to your mobile banking app to authorise this payment. It’s simple and secure – and it’ll help protect you from online fraud.',
	viewPayments: 'View our Payments',
	reviewAndConfirm: 'Review and confirm',
	aboutThisPayment: 'About this payment',
	howToAuthoriseGroupApprovals:
		'This payment is awaiting authorisation using one of our online security methods. We’ve sent a notification to users who can approve this payment.',
	howToAuthoriseBacsDetailsForOther:
		'This payment is awaiting authorisation by the user above using one of our online security methods. This user will have received a notification letting them know they had a payment to authorise when the payment was first submitted.',
	howToAuthoriseBacsDetailsForOtherPlural:
		'This payment is awaiting authorisation by the users above using one of our online security methods. These users will have received a notification letting them know they had a payment to authorise when the payment was first submitted.',
	by: 'By',
	paymentStatus: 'Payment Status',
	iftSameCurrencyTitle: 'Please review the payment details below before you provide authorisation.',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
